import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
/**
 * @return the built StageGroup entity
 */
export function toStageGroup(stageGroup) {
    checkDefined(stageGroup.populationId, 'StageGroup', 'populationId');
    checkDefined(stageGroup.stageIds, 'StageGroup', 'stageIds');
    return {
        ...toBaseStudyEntity(stageGroup, StudyEntityType.StageGroup),
        populationId: stageGroup.populationId,
        stageIds: stageGroup.stageIds.map(stageId => stageId),
    };
}
//# sourceMappingURL=stage-group.js.map